import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/testmap',
    name: 'testmap',
    component: () => import('../views/MapView.vue'),
    meta: { name: 'testmap', keepAlive: true },
  },
  {
    path: '/',
    name: 'sdmap',
    component: () => import('../views/OneMapView/index.vue'),
    meta: { name: 'sdmap', keepAlive: true },
  },
  {
    path: '/sharingMap',
    name: 'sharingMap',
    component: () => import('../views/SharingMap.vue'),
    meta: { name: 'sharingMap', keepAlive: true },
  },
  {
    path: '/onemap',
    name: 'onemap',
    component: () => import('../views/OneMapView/OneMap.vue'),
    meta: { name: 'onemap', keepAlive: true },
  },
  {
    path: '/editorMap',
    name: 'editorMap',
    component: () => import('../views/EditorMap.vue'),
    meta: { name: 'editorMap', keepAlive: true },
  },
  {
    path: '/goview',
    name: 'goview',
    component: () => import('../views/GoViewPreview.vue'),
    meta: { name: 'goview', keepAlive: true },
  },
  {
    path: '/erlunyanbaomap', //默认首页
    name: 'erlunyanbaomap',
    component: () => import('../views/ErLunYanBaoMapView.vue'),
    meta: { name: 'erlunyanbaomap',description:'二轮延包地图页面', keepAlive: true },
    
  },
  {
    path: '/chanquanbigdatamap',
    name: 'chanquanbigdatamap',
    component: () => import( '../views/ChuanQuanBigDataMapView.vue'),
    meta: { name: 'chanquanbigdatamap', description:'产权大数据地图页面', keepAlive: true },
  },
  {
    path: '/tdqq',
    name: 'tdqq',
    component: () => import( '../views/TuDiQueQuanMapView.vue'),
    meta: { name: 'tdqq', description:'土地确权地图页面', keepAlive: true },
  },
  {
    path: '/test',
    name: 'test',
    component: () => import( '../views/TestView.vue'),
    meta: { name: 'test', description:'测试', keepAlive: true },
  },
]

const router = new VueRouter({
  routes
})

export default router
